<template>
    <div class="calendar">
        <Modal
                @on-ok="addTextRecord"
                title="添加文案数据"
                v-model="modalText"
                :closable="false"
                :mask-closable="false">
            <div class="modal1-div">
                <div style="padding-bottom: 10px">
                    <p>来源:</p>
                    <Input v-model="sourceInput" placeholder="请输入文案来源" clearable style="min-width: 100px; width:100%"/>
                </div>
                <div>
                    <p>内容：</p>
                    <Input v-model="textInput" type="textarea" placeholder="请输入文案内容" clearable
                           style="min-width: 100px; width:100%"/>
                </div>
            </div>
        </Modal>
        <div class="calendar-text">
            <div class="table-head">
                <div class="table-title"><span style="font-weight: bold">文案数据</span></div>
                <div>
                    <Button @click="modalText=true">添加</Button>
                </div>
            </div>
            <Table :columns="textColumns" :data="textData">
                <template slot-scope="{ row, index }" slot="id">
                    <span>{{ row.id }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="text">
                    <template v-if="editIndex === index">
                        <i-Input type="textarea" v-model="textUpdate"/>
                    </template>
                    <span v-else>{{ row.text }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="source">
                    <template v-if="editIndex === index">
                        <i-Input type="text" v-model="sourceUpdate"/>
                    </template>
                    <span v-else>{{ row.source }}</span>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div v-if="editIndex === index">
                        <Button @click="handleSave(row,index)">保存</Button>
                        <Button style="margin-left: 10px" @click="editIndex = -1">取消</Button>
                    </div>
                    <div v-else>
                        <Button @click="handleEdit(row, index)">修改</Button>
                        <Button style="margin-left: 10px" @click="deleteTextRecord(row, index)">删除</Button>
                    </div>
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
    import apis from "../../http/api";
    import OSS from 'ali-oss';

    export default {
        name: "calendar",
        data() {
            return {
                ossClient: null,
                editIndex: -1,
                modalText: false,
                textInput: "",
                sourceInput: "",
                textUpdate: "",
                sourceUpdate: "",
                textData: [],
                textColumns: [
                    {
                        title: 'id',
                        slot: 'id',
                        width: '70px',
                    },
                    {
                        title: '内容',
                        slot: 'text',
                        width: '',
                    },
                    {
                        title: '来源',
                        slot: 'source',
                        width: '200px',
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 180
                    }
                ]
            }
        },
        async created() {
            this.getTextRecords()
        },
        methods: {
            getTextRecords(){
                apis.calendar_get_text_records().then(res=>{
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.textData = data.records
                    }
                })
            },
            async addTextRecord(){
                let post_data = {
                    text:this.textInput,
                    source:this.sourceInput
                }
                await apis.calendar_add_text_records(post_data).then(res=>{
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.$Message.success('添加成功');
                        this.textInput = "";
                        this.sourceInput = ""
                    }
                })
                await this.getTextRecords()
            },
            async updateTextRecord(row){
                let post_data = {
                    id:row.id,
                    text:this.textUpdate,
                    source:this.sourceUpdate
                }
                await apis.calendar_update_text_records(post_data).then(res=>{
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {
                        this.$Message.success('修改成功');
                    }
                })
            },
            async deleteTextRecord(row) {
                let post_data = {
                    id: row.id,
                }
                await apis.calendar_delete_text_record(post_data).then(res => {
                    const {data, errCode, msg} = res;
                    if (errCode === 0) {

                    }
                }).catch()
                await this.getTextRecords()

            },
            handleEdit(row, index) {
                this.textUpdate = row.text;
                this.sourceUpdate = row.source;
                this.editIndex = index;
            },
            async handleSave(row,index) {
                await this.updateTextRecord(row);
                this.editIndex = -1;
                await this.getTextRecords();
            },
        },
        computed: {}
    }
</script>

<style scoped>
    .calendar {
        margin: 10px;
    }

    .table-head {
        display: flex;
        justify-content: space-between;
        padding-bottom: 5px;
    }

    .table-title {
        align-self: center;
    }

</style>